import { BaseTier } from "./tier-base.model";
import { ContainerPrices } from "../shared/container/container-prices.model";

export class FclTier extends BaseTier {
  constructor(
    public id: number,
    protected discriminator: string,
    protected name: string,
    protected description: string,
    protected containers: ContainerPrices,
  ) {
    super(id, discriminator, name, description);
  }

  public getContainers(): ContainerPrices {
    return this.containers;
  }

  public getRequestParams(): any {
    return {
      name: this.getName(),
      description: this.getDescription(),
      containers: this.getContainers().getRequestParams(),
    };
  }
}
